<template>
  <div
    class="Form_group"
    :class="{ 'error': hasErrors }"
    :data-name="dataName"
  >
    <div class="Form_group_content">
      <label class="Form_label" v-if="label">{{ label }}</label>
      <input
        class="Form_control"
        :placeholder="placeholder"
        :value="value"
        :text="text"
        v-bind="$attrs"
        v-on="listeners"
        @change.native="change"
        :autocomplete="autocomplete"
        :type="$attrs.type || 'text'"
      >
    </div>
    <p class="tip-error" v-for="(error, index) in errors" :key="index">{{ label || text || placeholder }} {{ error }}</p>
    <p class="tip-error" v-if="triggerChange">{{ tips }}</p>
  </div>
</template>

<script>
  import InputMixin from './input'
  import ValidationMixin from './validation'

  export default {
    mixins: [InputMixin, ValidationMixin],

    methods: {
      change () {
        if (this.triggerChange) {
          this.$emit('change')
        }
      }
    }
  }
</script>
